"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeUniswapPairAddress = exports.sortTokens = exports.toChecksum = exports.toAddress = void 0;
var address_1 = require("@ethersproject/address");
var utils_1 = require("ethers/lib/utils");
var constants_1 = require("../constants");
function toAddress(obj) {
    if (typeof obj == 'string')
        return obj;
    var _obj = obj;
    return _obj.address || _obj.options.address;
}
exports.toAddress = toAddress;
function toChecksum(obj) {
    return address_1.getAddress(toAddress(obj));
}
exports.toChecksum = toChecksum;
var addressToBuffer = function (address) { return Buffer.from(address.slice(2).padStart(40, '0'), 'hex'); };
function sortTokens(tokenA, tokenB) {
    return (tokenA.toLowerCase() < tokenB.toLowerCase()) ? [tokenA, tokenB] : [tokenB, tokenA];
}
exports.sortTokens = sortTokens;
function computeUniswapPairAddress(tokenA, tokenB) {
    var initCodeHash = '0x96e8ac4277198ff8b6f785478aa9a39f403cb768dd02cbee326c3e7da348845f';
    var _a = sortTokens(tokenA, tokenB), token0 = _a[0], token1 = _a[1];
    var salt = utils_1.keccak256(Buffer.concat([addressToBuffer(token0), addressToBuffer(token1)]));
    return address_1.getCreate2Address(constants_1.UNISWAP_FACTORY, salt, initCodeHash);
}
exports.computeUniswapPairAddress = computeUniswapPairAddress;
